import { render } from "./TheHeader.vue?vue&type=template&id=3d97642f"
import script from "./TheHeader.vue?vue&type=script&lang=ts"
export * from "./TheHeader.vue?vue&type=script&lang=ts"

import "./TheHeader.vue?vue&type=style&index=0&id=3d97642f&lang=css"
script.render = render

export default script